var _path, _path2, _g, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPadLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2863 21.7053H14.7994C12.7647 21.7053 11.1152 23.3548 11.1152 25.3895V28.1607V38.3534V41.8041C11.1152 43.8389 12.7647 45.4883 14.7994 45.4883H37.2863C39.321 45.4883 40.9705 43.8389 40.9705 41.8041V38.404V38.3534V28.1607V25.3895C40.9705 23.3548 39.321 21.7053 37.2863 21.7053Z",
    fill: "url(#paint0_linear_7240_24555)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5157 22.0915V16.9336C34.5157 12.2538 30.7219 8.45996 26.042 8.45996V8.45996C21.3622 8.45996 17.5684 12.2538 17.5684 16.9336V22.0915",
    stroke: "url(#paint1_linear_7240_24555)",
    strokeWidth: 2.02409
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7240_24555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.78027,
    y: 27.3425,
    width: 40.5263,
    height: 11.7895,
    rx: 3.68421,
    fill: "url(#paint2_linear_7240_24555)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.88148,
    y: 27.4437,
    width: 40.3239,
    height: 11.5871,
    rx: 3.58301,
    stroke: "white",
    strokeWidth: 0.202409
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0586 32.1509L18.4409 34.681",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0586 34.6812L18.4409 32.151",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 30.8857L16.25 35.946",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.501 32.1511L27.8833 34.6812",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.501 34.6812L27.8833 32.151",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6934 30.886L25.6934 35.9462",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9434 32.1511L37.3256 34.6812",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9434 34.6812L37.3256 32.151",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1357 30.886L35.1357 35.9462",
    stroke: "white",
    strokeWidth: 1.18552,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7240_24555",
    x: 5.78027,
    y: 27.3425,
    width: 40.5264,
    height: 13.8136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.02409
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01204
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7240_24555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24555",
    x1: 13.3923,
    y1: 21.7053,
    x2: 40.2115,
    y2: 44.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24555",
    x1: 26.042,
    y1: 8.45996,
    x2: 26.042,
    y2: 22.0915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3935E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7240_24555",
    x1: 8.15564,
    y1: 28.2568,
    x2: 26.0434,
    y2: 39.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C183FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPadLock);
export default __webpack_public_path__ + "static/media/icon_pad_lock.fca14399cb0415a495c1cdcf70342799.svg";
export { ForwardRef as ReactComponent };